import React, { useSyncExternalStore } from 'react';
import { EyeOff } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { estSuperAdmin } from './FtpeMasqueToggle';

const CLE = 'echeancier_proposition_masque';
const EVT = 'echeancier-proposition-masque';
const lire = () => sessionStorage.getItem(CLE) === '1';
const abonner = (cb) => { window.addEventListener(EVT, cb); return () => window.removeEventListener(EVT, cb); };

/** Vrai si le super admin a masqué l'échéancier (contrôlé côté serveur). */
export const echeancierMasque = () => lire();

export const useEcheancierMasque = () => {
  const masque = useSyncExternalStore(abonner, lire);
  const set = (v) => { sessionStorage.setItem(CLE, v ? '1' : '0'); window.dispatchEvent(new Event(EVT)); };
  return [masque, set];
};

export default function EcheancierMasqueToggle() {
  const { user } = useAuth();
  const [masque, setMasque] = useEcheancierMasque();
  if (!estSuperAdmin(user)) return null;
  return (
    <label className="mt-3 flex cursor-pointer items-center gap-2 rounded-lg border border-dashed border-amber-400 bg-amber-50 px-3 py-2 text-xs font-semibold text-amber-800" data-testid="echeancier-masque-toggle">
      <input type="checkbox" checked={masque} onChange={(e) => setMasque(e.target.checked)} className="h-4 w-4 accent-amber-600" data-testid="echeancier-masque-checkbox" />
      <EyeOff className="h-3.5 w-3.5" /> Super Admin — masquer l'échéancier (paiement échelonné) : écran et proposition PDF
    </label>
  );
}
